import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache ={
  hero_image: "/images/daniel-hero.jpg",
  quote_image: "/images/coucher-soleil-original.webp",
  about_image: "/images/daniel-about.jpg",
  autumn_image: "/images/decor-automne-original.webp",
  facebook_url: "https://www.facebook.com/profile.php?id=61590682801400",
  instagram_url: "https://www.instagram.com/evasionimagesphoto/",
  youtube_url: "https://www.youtube.com/channel/UCAeDL1fTv0FPK68tfdn2dvwL",
  tiktok_url: "https://www.tiktok.com/@danieldulude616?lang=fr"
}

export function useSiteContent() {
  const [content, setContent] = useState(cache || {});

  useEffect(() => {
    if (cache) return;
    api.get("/content").then(({ data }) => {
      cache = data && typeof data === "object" && !Array.isArray(data) ? data : {};
      setContent(cache);
    }).catch(() => {});
  }, []);

  return content;
}
